import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { SeedCoatingRequest } from '../../../models/tankmixRequest';
import { CountryList, Country } from '../../../models/countries';
import { ApiService } from '../../../services/api.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { format } from 'date-fns';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'app-request-seed-treatment',
  templateUrl: './helena-request-seed-treatment.component.html'
})
export class HelenaRequestSeedTreatmentComponent implements OnInit {

  @ViewChild('formedEmail', { read: ElementRef }) formedEmail: ElementRef;
  seedCoatingRequestForm: | UntypedFormGroup;
  applicationUnitChoices: string[] = ['Litres', 'Millilitres', 'Kilogrammes', 'Grammes'];
  countryChoices: Country[] = CountryList;
  invalidIngredients: boolean = false;
  constructor(private api: ApiService, 
    private fb: UntypedFormBuilder,
    private router: Router,
    private preferenceService:PreferencesService) { }

  ngOnInit() {
    this.preferenceService.forceToAmerica();
    var today=new Date();
    this.seedCoatingRequestForm = this.fb.group({
      kind:['seed'],
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      company: [null],
      country: [null, Validators.required],
      requestDate: [format(today,'yyyy-MM-dd'), Validators.required],
      waterRate: [null],
      seedName: [null],
      comments: [null],
      ndaRef: [null],
      ingredients: this.fb.array([])
    });
    this.addProduct();
  }
  get name() { return this.seedCoatingRequestForm.get('name'); }
  get email() { return this.seedCoatingRequestForm.get('email'); }
  get company() { return this.seedCoatingRequestForm.get('company'); }
  get waterRate() { return this.seedCoatingRequestForm.get('waterRate'); }
  get requestDate() { return this.seedCoatingRequestForm.get('requestDate'); }
  get country() { return this.seedCoatingRequestForm.get('country'); }
  get ndaRef() { return this.seedCoatingRequestForm.get('ndaRef'); }

  get formValues():any{
    return this.seedCoatingRequestForm.value;
  }
  get ingredients(): UntypedFormArray {
    return this.seedCoatingRequestForm.get('ingredients') as UntypedFormArray;
  }
  addProduct() {
    
    this.ingredients.push(this.fb.group(
      {
        name: [null,Validators.required],
        orderOfAddition: [this.ingredients.length + 1],
        applicationRate: [null,Validators.required],
        applicationUnit: ['', Validators.required]
      }
    ));
  }
  deleteProduct(index) {
    console.log('Deleting product');
    this.ingredients.removeAt(index);
  }
  submitRequest() {

    if (this.seedCoatingRequestForm.valid) {

      if (!this.areIngredientsInvalid()) {
        console.log('valid ingredients');
        const html = document.getElementById('formedEmail').innerHTML;
        this.api.submitRequest(this.seedCoatingRequestForm.value, html).subscribe(data =>
          {
            this.router.navigateByUrl('request-submitted');
          }
        );
       
      }
      else {
        console.log('no ingredients data - Invalid submission')
      }

    }
    
  }

  areIngredientsInvalid() {
    
    console.log('si');
    var result = (this.ingredients.controls.some(x => x.get('name').value === null || x.get('name').value === '')
    ||  this.ingredients.controls.some(x => x.get('applicationRate').value === null || x.get('applicationRate').value === ''));    
    console.log(result);
    this.invalidIngredients = result;
    return  result;
  }

}
